import { css } from '@goodhuman-me/components';

export const reset = css({
  boxSizing: 'border-box',
  position: 'relative',
  overflow: 'visible !important',
});
